import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { FlashMessagesService } from 'angular2-flash-messages';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { HEADERS } from './../constante';
import { Entrevista } from './entrevista';

@Injectable()
export class EntrevistaService {

  private headers = HEADERS;
  private entrevistaUrl = URL_API + "/entrevistas";
  private entrevUrl = URL_API + "/entrevista";
  private entrevEncamUrl = URL_API + "/nomesentrevista";

  constructor(
    private http: Http,
    private _flashMessagesService: FlashMessagesService
  ) { }

  getEntrevistas(id:number): Promise<Entrevista[]> {
      let url: string = this.entrevistaUrl + "/" + id;
      return this.http.get(url)
                    .toPromise()
                    .then(response => response.json() as Entrevista[])
                    .catch(this.handleError);
  }

  getDadosEntrevista(id:number): Promise<Entrevista> {
      //console.log("Servico. Id entrevista = " + id);
      let url: string = this.entrevUrl + "/" + id;
      return this.http.get(url)
                    .toPromise()
                    .then(response => response.json() as Entrevista)
                    .catch(this.handleError);
  }

  saveEntrevista(entrevista: Entrevista): Promise<Entrevista>{
    let url: string = this.entrevistaUrl;
    //console.log("AQUI ");
    //console.log(entrevista);
    //console.log("ALI");
    return this.http
               .post(url, JSON.stringify(entrevista), {headers: HEADERS})
               .toPromise()
               .then(response => this.handleSuccess(response.json()))
               .catch((error) => this.handleError(error));
  }

  getNomesEntrevistaEncaminhados(id: number): Promise<Entrevista[]> {
    //console.log("id incid = " + id);
    let url: string = this.entrevEncamUrl + "/" + id;
    return this.http.get(url)
                  .toPromise()
                  .then(response => response.json() as Entrevista[])
                  .catch(this.handleError);
  }


private handleSuccess(resp: any): Promise<any> {
  this._flashMessagesService.show(resp, { cssClass: 'alert-success', timeout: 30000 });
  return resp;
}

private handleError(error: any): Promise<any> {
  //console.log(error)
  switch (error.status) {
    case 500:
      this._flashMessagesService.show("Ocorreu erro no servidor, entre em contato com o administrador.", { cssClass: 'alert-danger', timeout: 15000 });
      break;
    case 403:
      this._flashMessagesService.show(error.json().msg, { cssClass: 'alert-warning', timeout: 25000 });
      break;
    default:
      this._flashMessagesService.show("Ocorreu um erro, tente novamente mais tarde.", { cssClass: 'alert-danger', timeout: 15000 });

  }

  return Promise.reject(error.message || error);

}


}



// WEBPACK FOOTER //
// ./src/app/entrevistas/entrevista.service.ts